import Vue from 'vue'
import Router from 'vue-router'
import SignUp from '@/components/SignUp'
import Login from '@/components/Login'
import Home from '@/components/Home'
import Registration from '@/components/Registration'
import Step1 from '@/components/steps/Step1'
import Step2 from '@/components/steps/Step2'
import Step3 from '@/components/steps/Step3'
import Details from '@/components/Details'
import EditProfile from '@/components/EditProfile'
import Approve from '@/components/admin/Approve'
import Decline from '@/components/admin/Decline'
import NotFoundComponent from '@/components/NotFound'
import ForgotPassword from '@/components/ForgotPassword'
import ChangePassword from '@/components/ChangePassword'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/signup',
      name: 'SignUp',
      component: SignUp
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },,
    {
      path: '/details/:user_id',
      name: 'Details',
      component: Details
    },
    {
      path: '/registration',
      name: 'Registration',
      component: Registration,
      props: true,
      children:[
        {
          path: '/step1',
          name: 'Step1',
          component: Step1,
          props: true
        },
        {
          path: '/step2',
          name: 'Step2',
          component: Step2,
          props: true
        },
        {
          path: '/step3',
          name: 'Step3',
          component: Step3,
          props: true
        }
      ]
    },
    {
      path: '/editprofile',
      name: 'EditProfile',
      component: EditProfile
    },
    {
      path: '/approve/:token',
      name: 'Approve',
      component: Approve
    },
    {
      path: '/decline/:token',
      name: 'Decline',
      component: Decline
    },
    {
      path: '/forgotpassword',
      name: 'ForgotPassword',
      component: ForgotPassword
    },
    {
      path: '/changepassword',
      name: 'ChangePassword',
      component: ChangePassword,
      props: (route) => ({
        mode: route.query.mode,
        oobCode: route.query.oobCode,
        lang: route.query.lang
      })
    },
    {
      path: '*',
      component: NotFoundComponent
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js